module.exports = __webpack_public_path__ + "media/unipod/bathroom-pod-card-picture-9a516c14.jpg";